import { Component, Inject } from '@angular/core';
import { signatureItems } from '../../constants/signatureConstants';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-signature-modal',
  templateUrl: './signature-modal.component.html',
  styleUrls: ['./signature-modal.component.scss']
})
export class SignatureModalComponent {
  status:any;
  signatureItems = signatureItems;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SignatureModalComponent>
  ) { 
    this.status = this.data;
  }
}
